import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import config from '../config';

const PortalContext = createContext();

export const usePortal = () => {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortal must be used within a PortalProvider');
  }
  return context;
};

export const PortalProvider = ({ children }) => {
  const { token } = useAuth();
  const [portalSettings, setPortalSettings] = useState({
    portalName: 'Portal',
    registrationEnabled: true
  });
  const [loading, setLoading] = useState(true);

  const fetchPortalSettings = async () => {
    if (!token) return;
    
    try {
      const response = await fetch(`${config.apiUrl}/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setPortalSettings(data);
        
        // Update document title
        document.title = data.portalName || 'Portal';
      }
    } catch (error) {
      console.error('Error fetching portal settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const updatePortalSettings = async (newSettings) => {
    try {
      const response = await fetch(`${config.apiUrl}/admin/settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newSettings)
      });
      
      if (response.ok) {
        const data = await response.json();
        setPortalSettings(data);
        
        // Update document title
        document.title = data.portalName || 'Portal';
        
        return { success: true, data };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  useEffect(() => {
    fetchPortalSettings();
  }, [token]);

  const value = {
    portalSettings,
    loading,
    fetchPortalSettings,
    updatePortalSettings
  };

  return (
    <PortalContext.Provider value={value}>
      {children}
    </PortalContext.Provider>
  );
};
